module.exports = __webpack_public_path__ + "img/w19-cover.9cbebbbd.jpg";